import parse from "html-react-parser"

import { getSafeHtmlParserOptions } from "./getSafeHtmlParserOptions"

/**
 * Helper function to parse SVG and replace paint attributes with currentColor
 * This allows SVG icons to inherit the text color from their parent element
 *
 * @param svgString - The SVG string to parse and modify
 * @returns Parsed React elements with currentColor applied to explicit paint attributes
 */
const shouldUseCurrentColor = (value?: string) => {
  if (!value) return false

  const normalizedValue = value.trim().toLowerCase()

  return (
    normalizedValue !== "none" &&
    normalizedValue !== "transparent" &&
    !normalizedValue.startsWith("url(")
  )
}

const replacePaintWithCurrentColor = (
  attribs: Record<string, string>,
  attributeName: string
) => {
  if (Object.prototype.hasOwnProperty.call(attribs, attributeName)) {
    const value = attribs[attributeName]

    if (shouldUseCurrentColor(value)) {
      attribs[attributeName] = "currentColor"
    }
  }
}

export const parseSvgWithCurrentColor = (svgString: string) => {
  return parse(
    svgString,
    getSafeHtmlParserOptions((domNode) => {
      if (domNode.type === "tag" && domNode.attribs) {
        domNode.attribs["aria-hidden"] = "true"
        domNode.attribs.focusable = "false"
        domNode.attribs.tabIndex = "-1"
        delete domNode.attribs.tabindex

        replacePaintWithCurrentColor(domNode.attribs, "fill")
        replacePaintWithCurrentColor(domNode.attribs, "stroke")
        replacePaintWithCurrentColor(domNode.attribs, "stopColor")
        replacePaintWithCurrentColor(domNode.attribs, "stop-color")
      }
      return domNode
    })
  )
}
